// KAN-899: "a new version is available" banner for the customer + shipper portals.
//
// The ERP has its own (index.html markup + a service worker to activate). The portals register no
// service worker, so there is no SKIP_WAITING dance here — a plain reload picks up the new assets.
//
// Deliberately click-to-reload only. Portal sessions are short and transactional (check an order,
// submit a quote), so a reload the user did not ask for could throw away a half-finished quote to
// fix a staleness they would never have noticed. The ERP's auto-accept (KAN-900) exists for wall
// displays, which have no such state to lose.

import { startVersionPolling } from './modules/version-check.js';
import './update-banner.css';

const BANNER_ID = 'portal-update-banner';

function _render() {
  if (document.getElementById(BANNER_ID)) return;

  const bar = document.createElement('div');
  bar.id = BANNER_ID;
  bar.className = 'portal-update-banner';
  bar.setAttribute('role', 'status');

  const msg = document.createElement('span');
  msg.className = 'portal-update-banner__msg';
  msg.textContent = 'A new version is available.';

  const refresh = document.createElement('button');
  refresh.type = 'button';
  refresh.className = 'portal-update-banner__refresh';
  refresh.textContent = 'Refresh';
  refresh.addEventListener('click', () => window.location.reload());

  const dismiss = document.createElement('button');
  dismiss.type = 'button';
  dismiss.className = 'portal-update-banner__dismiss';
  dismiss.setAttribute('aria-label', 'Dismiss');
  dismiss.textContent = '✕';
  dismiss.addEventListener('click', () => bar.remove());

  bar.append(msg, refresh, dismiss);
  document.body.appendChild(bar);
}

/**
 * Watch for a newer deployment and offer a reload.
 *
 * Built from DOM nodes rather than innerHTML: nothing here is user data today, but a banner is the
 * kind of thing that later grows a "what changed" string from somewhere less trustworthy.
 */
export function mountUpdateBanner() {
  startVersionPolling(() => _render());
}
